import * as React from "react";


import "./AdminOffer.scss";
import {Box, Card, IconButton} from "@mui/material";

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import {checkUserAllowed, getImage, getLocalDate} from "helpers/utils";
import {DATE_TIME_FORMAT_SHORT} from "config/constants";
import {H2, H5} from "components/CustomTypography";
import ViewListIcon from "@mui/icons-material/ViewList";


const AdminSalesLog = (props) => {
  const { saleslog = {}, userDetails, editCategorySettings, className = "" } = props;
  const { id, name, images = [], is_popular, is_active, store_entry } = saleslog;

  return (
      <Box pb={2}>
          <HoverBox  mb={0} mx="auto" borderRadius="2px" onClick={editCategorySettings}>
              <LazyImage
                  src={getImage(saleslog.images)}
                  width={150}
                  height={150}
                  alt={saleslog.name}
                  mx="auto"
              />
          </HoverBox>
          <H2 textTransform="uppercase" fontSize={12} textAlign="left" title={saleslog.shop && saleslog.shop.title} ellipsis>
              {saleslog.shop && saleslog.shop.title} {saleslog.shop && saleslog.shop.is_tracked && <b> (High Priority)</b>}
          </H2>
          <H5 fontSize={12} textAlign="left" title={saleslog.name} ellipsis>
              ({saleslog.status})  ({saleslog.interest})
          </H5>
          <H5 fontSize={12} textAlign="left" title={saleslog.name} ellipsis>
              ({saleslog.scope && saleslog.scope.join(' | ')})
          </H5>
          <H5 fontSize={12} textAlign="left" ellipsis>
             {getLocalDate(saleslog.created_at, DATE_TIME_FORMAT_SHORT)}
          </H5>
          <H5 fontSize={12} textAlign="left" ellipsis>
              {saleslog.shop && getLocalDate(saleslog.shop.created_at, DATE_TIME_FORMAT_SHORT)}
          </H5>
          <H5 fontSize={12} textAlign="left" ellipsis>
              {saleslog.sales_user && saleslog.sales_user.name}
          </H5>
          <Box display="flex">
              <IconButton className="setting-button" color="primary" size="small" onClick={editCategorySettings}>
                  <MoreHorizIcon />
              </IconButton>
          </Box>
      </Box>
  );
};

export default AdminSalesLog;
